/**
 * Dr. Herança Tenant Component Enum
 * Defines available tenant-specific components
 */
export enum DrHerancaComponent {
  Home = 'Home',
  LandingCalculadoraInventario = 'LandingCalculadoraInventario',
  InventoriesList = 'InventoriesList',
  InventoryDelete = 'InventoryDelete',
  InventoryFamilyTree = 'InventoryFamilyTree',
  InventoryHome = 'InventoryHome',
  UserProfile = 'UserProfile',
}